import { Text, View } from '@react-pdf/renderer';

import { styles } from './styles';

type SiteInformationProps = {
  name: string | string[];
  items?: string[] | React.ReactNode[];
};

export function SiteInformation({ name, items }: SiteInformationProps) {
  const names = Array(name).flat();

  return (
    <View style={styles.section}>
      {names.map((name, i) => (
        <Text key={`${name}-${i}`} style={styles.bold}>
          {name}
        </Text>
      ))}

      {items?.map((item, i) => {
        if (typeof item === 'string') {
          return <Text key={`${item}-${i}`}>{item}</Text>;
        }
        return item;
      })}
    </View>
  );
}
